import React from 'react';
import multiHalfStyle from './style';

export default function MultiHalf({first, second, mt}) {
	let style = multiHalfStyle();

	return (
		<div style={style.outerStyle(mt)}>
			{first ? <h3 className='col-6 mx-auto text-center'>{first}</h3> : <></>}
			{second ? <h3 className='col-6 mx-auto text-center'>{second}</h3> : <></>}
		</div>
	);
}
